import React from 'react'
import { Row, Col, Card } from 'antd'
import he from 'he'

import sortByPortAndDay from 'components/sortByPortAndDay'
import ProgramCard from './ProgramCard'
import moment from 'components/momentWithZone'

export default class ProgramCardList extends React.Component {
	state = {
		ports: [],
		portOrder: [],
	}

	getPorts = async () => {
		if (!this.props.booking.EventId) return

		try {
			const response = await fetch(
				`/api/voyages/${this.props.booking.EventId}/ports`
			)

			if (!response.ok) {
				throw new Error(response.statusText)
			}

			const ports = await response.json()
			const portOrder = ports.map((port) => port.portCode)

			this.setState({ ports, portOrder })
		} catch (error) {
			console.error(error)
		}
	}

	componentDidMount() {
		this.getPorts()
	}

	render() {
		let i = 0
		let lastPort = null
		let today = moment()
		return (
			<Row className='ql-editor'>
				{this.props.programs
					.sort(sortByPortAndDay(this.state.portOrder))
					.map((program) => {
						if (program) {
							i += 1

							const inventoryItem =
								typeof this.props.inventory === 'undefined'
									? { visible: true }
									: Object.assign(
											{ bookable: false },
											this.props.inventory[program.Code]
									  )

							let newPort =
								lastPort === null ||
								program.Code.substring(0, 3) !== lastPort
									? program.Code.substring(0, 3)
									: false

							const matchingPort = this.state.ports.find(
								(port) => port.portCode === newPort
							)

							if (newPort && matchingPort)
								newPort = `${matchingPort.portName}, ${matchingPort.country}`

							lastPort = program.Code.substring(0, 3)

							const title = he.decode(program.Title)

							let colClassNames = ['programCardCol']
							if (this.props.cardProps.shouldShowSpotsLeft)
								colClassNames.push('taller')

							let itcvalidatebegdate = inventoryItem
								? moment(inventoryItem.itcValidBegDate)
								: moment()
							let itcvalideenddate = inventoryItem
								? moment(inventoryItem.itcValidEndDate)
								: moment()

							return (
								<div key={i}>
									{newPort && (
										<Col
											span={24}
											style={{ marginTop: '16pt' }}
										>
											<h2>{newPort}</h2>
											<hr />
										</Col>
									)}
									<Col
										xs={24}
										sm={12}
										md={8}
										xl={6}
										className={colClassNames.join(' ')}
									>
										<ProgramCard
											rescoItem={inventoryItem}
											inCart={
												typeof this.props.cart ===
												'undefined'
													? false
													: !!this.props.cart.find(
															(cartProgram) =>
																cartProgram.ExcursionId ===
																program.ExcursionId
													  )
											}
											inBooking={
												typeof this.props
													.bookedItems === 'undefined'
													? false
													: !!this.props.bookedItems.find(
															(bookedItem) =>
																inventoryItem &&
																bookedItem.ItemId ===
																	inventoryItem.ItemId
													  )
											}
											showCartButton={
												/*
											this.props.shouldShowCartButtons &&
											inventoryItem && inventoryItem.bookable
											*/
												this.props
													.shouldShowCartButtons &&
												inventoryItem &&
												inventoryItem.bookable &&
												today.diff(itcvalidatebegdate) >
													0 &&
												today.diff(itcvalideenddate) < 0
											}
											blocked={
												typeof this.props.blocked ===
												'function'
													? this.props.blocked(
															inventoryItem
													  )
													: false
											}
											availability={
												inventoryItem &&
												inventoryItem.available
											}
											price={
												inventoryItem &&
												inventoryItem.price
											}
											{...this.props.cardProps}
											{...{ program, title }}
											TripCode={
												this.props.booking.TripCode
											}
										/>
									</Col>
								</div>
							)
						} else {
							i += 1
							return (
								<Col
									key={i}
									xs={24}
									sm={12}
									md={8}
									xl={6}
									style={{ padding: '4pt', height: '490px' }}
								>
									<Card loading />
								</Col>
							)
						}
					})}
			</Row>
		)
	}
}



// WEBPACK FOOTER //
// ./portal-components/Portal/FieldPrograms/ProgramCardList/index.jsx